import {FocusLock} from '../utils/focus-lock';
import {disablePageScroll, enablePageScroll} from '../vendor/scroll-lock';

const focusLock = new FocusLock();

const mainNav = document.querySelector('.main-nav');
const mainNavBtn = document.querySelector('[data-nav-toggle]');
const mainNavWrapper = document.querySelector('.main-nav__wrapper');
const headerWrapper = document.querySelector('.header__wrapper');
const breakpoint = window.matchMedia('(max-width: 1023px)');

const replaceAriaLabel = () => {
  mainNavBtn.setAttribute('aria-label', mainNavBtn.dataset.navToggle);
};

// headerWrapper.classList.add('header__wrapper-fix');

const openMenu = () => {
  mainNav.classList.add('is-open');
  mainNavBtn.dataset.navToggle = 'Close menu';
  replaceAriaLabel();
  mainNavWrapper.classList.remove('hidden');
  document.addEventListener('click', onDocumentClick);
  document.addEventListener('keydown', onDocumentEscPress);
  disablePageScroll(mainNav);
  focusLock.lock('.main-nav');
  headerWrapper.classList.remove('header__wrapper-fix');
};

const closeMenu = () => {
  mainNav.classList.remove('is-open');
  mainNavBtn.dataset.navToggle = 'Open menu';
  replaceAriaLabel();
  setTimeout(() => {
    if (breakpoint.matches && !mainNavWrapper.classList.contains('hidden')) {
      mainNavWrapper.classList.add('hidden');
    }
  }, 400);
  document.removeEventListener('click', onDocumentClick);
  document.removeEventListener('keydown', onDocumentEscPress);
  enablePageScroll(mainNav);
  focusLock.unlock();
  headerWrapper.classList.add('header__wrapper-fix');
};

const breakpointChecker = () => {
  if (breakpoint.matches) {
    // mobile
    mainNavWrapper.classList.add('hidden');
    headerWrapper.classList.add('header__wrapper-fix');
  } else {
    // desktop
    if (mainNav.classList.contains('is-open')) {
      mainNav.classList.remove('is-open');
      mainNavBtn.dataset.navToggle = 'Close menu';
      replaceAriaLabel();
      enablePageScroll(mainNav);
      focusLock.unlock();
    }
    mainNavWrapper.classList.remove('hidden');
    headerWrapper.classList.remove('header__wrapper-fix');
  }
};

const onDocumentClick = (evt) => {
  if (!evt.target.closest('.main-nav')) {
    closeMenu();
  }
};

const onDocumentEscPress = function (evt) {
  if ((evt.key === 'Escape') && (evt.target.dataset.navToggle)) {
    evt.preventDefault();
    closeMenu();
  }
};

const initMenu = () => {
  if (mainNavBtn && mainNav) {
    document.addEventListener('click', (evt) => {
      if (breakpoint.matches &&
          (evt.target.closest('[data-nav-toggle]') || evt.target.closest('.main-nav a[href]'))) {
        if (mainNav.classList.contains('is-open')) {
          closeMenu();
        } else {
          openMenu();
        }
      }
    });

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  }
};

export {initMenu};
